module.exports = __webpack_public_path__ + "img/路线图页-地图C.53a34dc3.png";